import routes from './routes.js'
// import store from '../store'

import { createWebHistory } from 'vue-router'
import translations from '../lang/translations'
import localizedURLs from '../lang/localized-urls'
import { createLangRouter } from 'vue-lang-router'

const langRouterOptions = {
  defaultLanguage: 'ru',
  translations,
  localizedURLs,
}

const routerOptions = {
  history: createWebHistory(),
  routes,
}
const router = createLangRouter(langRouterOptions, routerOptions)

//Что-то делаем перед переходом
// router.beforeEach((to, from, next) => {

// })

//Что-то делаем после перехода
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);


  //Обновляем страницу когда идем с продуктов обратно на категорию
  // if (to.name === 'category' && from.name === 'products') {
  //   window.location.reload();
  // }
  //Обновляем страницу когда идем с продуктов обратно на главную
  // if (to.name === 'home' && from.name === 'products') {
  //   window.location.reload();
  // }
  //Обновляем страницу когда идем с продукта обратно на продукты категории
  // if (to.name === 'products' && from.name === 'product') {
  //   window.location.reload();
  // }
  //Обновляем страницу когда идем с продукта обратно на продукты категории
  // if (to.name === 'home' && from.name === 'product') {
  //   window.location.reload();
  // }

});

export default router;
